import { Field, InputType, ObjectType } from 'type-graphql'
import { modelOptions, Prop } from '@typegoose/typegoose'
import { SubCompany } from './SubCompany'
import { BaseEntity } from '../base/BaseEntity'
import { Address } from '../address/Address'
import { StatusEnum } from '../base/StatusEnum'

@ObjectType()
@InputType('CompanyInput')
@modelOptions({
  schemaOptions: {
    timestamps: true,
  },
})
export class Company extends BaseEntity {
  @Field(() => String)
  @Prop({ type: String })
  declare name: string

  @Field(() => String)
  @Prop({ type: String })
  domain: string

  @Field(() => Address)
  @Prop({ type: Address })
  address: Address

  @Field(() => [Address])
  @Prop({ type: [Address] })
  addresses: Address[]

  @Field(() => Company)
  @Prop({ type: () => SubCompany })
  parentCompany: Company

  @Prop({ type: () => [SubCompany] })
  subCompanies: Company[]

  @Field(() => String)
  @Prop({ type: String, enum: StatusEnum, default: StatusEnum.Active })
  declare status: StatusEnum
}
